import { useAuthStore } from '@/stores';

const VITE_API_URL = process.env.VUE_APP_API_URL || `http://localhost:5000/`;

export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    delete: request('DELETE'),
    'url': VITE_API_URL,
};

function request(method) {   
    return (url, body) => {
        var spinner = document.getElementById("spinner");
        spinner?.classList.add("show");

        const isApiUrl = url.startsWith(VITE_API_URL);
        if (!isApiUrl) {
            url = VITE_API_URL + url;
        }

        const requestOptions = {
            method,
            headers: authHeader(url),

            // ❌ DO NOT ADD credentials here
            // credentials: 'include'  <-- REMOVE if added anywhere
        };

        if (body instanceof FormData) {
            requestOptions.body = body;
        } else if (body) {
            requestOptions.headers['Content-Type'] = 'application/json';
            requestOptions.body = JSON.stringify(body);
        }

        return fetch(url, requestOptions).then(handleResponse);
    }
}

// =========================
// AUTH HEADER (CORRECT)
// =========================
// fetchWrapper — match what your middleware expects
function authHeader(url) {
  const { user } = useAuthStore();
  const isLoggedIn = !!user?.token;
  const isApiUrl = url.startsWith(VITE_API_URL);

  if (isLoggedIn && isApiUrl) {
    return {
      Authorization: `Bearer ${user.token}`, // ✅ consistent with GraphQL
    };
  }
  return {};
}

async function handleResponse(response) {
    const isJson = response.headers?.get('content-type')?.includes('application/json');
    const data = isJson ? await response.json() : null;
    var spinner = document.getElementById("spinner");
    if (!response.ok) {
        const { user, logout } = useAuthStore();

        if ([401, 403].includes(response.status) && user) {
            logout();
        }

        const error = (data && data.message) || response.status;

        spinner?.classList.remove("show");

        return Promise.reject(error);
    }

    spinner?.classList.remove("show");

    return data;
}